<div>
  <div class="row">
    <div class="col-print-12">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Service Details</label>
            </div>
          </div>

          <div class="row bordertop border-bot-1px margin-left-0px margin-right-0px margin-bottom-10px">
            <div class="col-print-6 margin-top-10">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CustomerName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{AgeY}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Order Code:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OrderNo}}</label>
                </div>
              </div>

            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Mobile No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{MobileNumber}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Order Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{OrderDate | date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>

            </div>

            <div class="col-print-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-3">
                  <label class="margin-bottom-0px font-family font-weight-normal">Address:</label>
                </div>
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DeliverToAddress}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>


          <div class="col-print-12">
            <div class="row margin-right-0px margin-left-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>

                          <th class="font-weight-normal width-35px background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                            #
                          </th>

                          <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                            Service Name
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of CurrentIohServiceitemData;let RowIndex = index">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.ItemName}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OrderStatus}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12 margin-top-10">
            <div class="row margin-left-0px">
              <div class="col-print-5">
                
                <div class="row margin-left-0px">
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family text-align-center font-weight-normal">Provider</label>
                  </div>
                  <div class="col-print-7">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal"></label>
                  </div>
                  <div class="col-print-7">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-10">
                    <label class="margin-bottom-0px font-family font-weight-bold">({{PrescName}})</label>
                  </div>
                  <!--<div class="col-print-1">
                    <label class="margin-bottom-0px font-family font-weight-bold">)</label>
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>-->
                </div>
              </div>
              <div class="col-print-3">

              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px">
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family text-align-center font-weight-normal">Incharge</label>
                  </div>
                  <div class="col-print-7">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal"></label>
                  </div>
                  <div class="col-print-7">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-10">
                    <label class="margin-bottom-0px font-family font-weight-bold">({{CreatedUser}})</label>
                  </div>
                  <!--<div class="col-print-1">
                    <label class="margin-bottom-0px font-family font-weight-bold">)</label>
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>-->
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>
  

<!--<printfooterview></printfooterview>-->
